import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { getSchoolCodes } from 'store/codes/actions';

import { Loading } from 'components/shared/Loading';

import { SchoolCodesTable } from 'components/SchoolCodesTable';
import { EmptyState } from 'components/EmptyState';

import { PromocodeActivationsChart } from '../PromocodeActivationsChart';

import { ActivationReportDateFilter } from './ActivationReportDateFilter';

import { CODES_TABLE_COLUMNS } from './ActivationCodes.tableConfig';

import styles from './ActivationCodes.module.scss';

const ActivationCodes = ({
  loading,
  codes,
  schoolId,
  sortParams,
  listFilterParams,
  activationFrom,
  activationTo,
  schoolPrefix,
  schoolPrefixOptions,
  prefixesLoading,
  onActivationFromChange,
  onActivationToChange,
  onSchoolPrefixChange,
  onSortChange,
  onCopyCodeClick,
}: {
  loading: any;
  codes: any;
  schoolId: string;
  sortParams: any;
  listFilterParams: Record<string, string>;
  activationFrom: string;
  activationTo: string;
  schoolPrefix: string;
  schoolPrefixOptions: string[];
  prefixesLoading: boolean;
  onActivationFromChange: (value: string) => void;
  onActivationToChange: (value: string) => void;
  onSchoolPrefixChange: (value: string) => void;
  onSortChange: any;
  onCopyCodeClick: any;
}) => (
  <div className={styles.root}>
    <ActivationReportDateFilter
      activationFrom={activationFrom}
      activationTo={activationTo}
      schoolPrefix={schoolPrefix}
      schoolPrefixOptions={schoolPrefixOptions}
      prefixesLoading={prefixesLoading}
      onActivationFromChange={onActivationFromChange}
      onActivationToChange={onActivationToChange}
      onSchoolPrefixChange={onSchoolPrefixChange}
    />
    <PromocodeActivationsChart schoolId={schoolId} />
    {loading ? (
      <Loading />
    ) : codes && codes.length > 0 ? (
      <SchoolCodesTable
        columns={CODES_TABLE_COLUMNS()}
        data={codes}
        params={sortParams}
        paginationQuery={listFilterParams}
        dataAction={({
          page,
          limit,
          sortBy,
          sortDirection,
          ...filterParams
        }: {
          page: any;
          limit: any;
          sortBy: any;
          sortDirection: any;
        }) =>
          getSchoolCodes({
            schoolId,
            params: { page, limit, sortBy, sortDirection, ...filterParams },
          })
        }
        onSortChange={onSortChange}
        onCopyCodeClick={onCopyCodeClick}
      />
    ) : (
      <EmptyState
        className={styles.emptyState}
        icon="hash"
        title={getTranslation('school_page.activation_codes.empty_state.title')}
        text={getTranslation('school_page.activation_codes.empty_state.text')}
      />
    )}
  </div>
);

export default React.memo(ActivationCodes) as any;
